import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=590c8508&scoped=true"
import script from "./SelectBox.vue?vue&type=script&lang=js"
export * from "./SelectBox.vue?vue&type=script&lang=js"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=590c8508&prod&lang=scss&scoped=true"
import style1 from "./SelectBox.vue?vue&type=style&index=1&id=590c8508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c8508",
  null
  
)

export default component.exports